import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TenantLayout from '../components/TenantLayout';
import { tenantsService } from '../services/tenants.service';
import { TenantDetail } from '../types/tenant';
import { getErrorMessage } from '../utils/error';
import TenantDashboardPage from './TenantDashboardPage';
import TenantDossierPage from './TenantDossierPage';

/**
 * « Voir son espace » : le propriétaire voit l'espace d'un de ses locataires
 * avec les écrans du locataire eux-mêmes, remplis par le dossier tel que le
 * locataire le reçoit. Aucune connexion à sa place.
 */
const ApercuEspaceLocatairePage: React.FC = () => {
  const { id, page } = useParams();
  const [apercu, setApercu] = useState<TenantDetail | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    tenantsService
      .getVueLocataire(id)
      .then(setApercu)
      .catch((err) => setError(getErrorMessage(err, "Impossible d'ouvrir l'espace de ce locataire")));
  }, [id]);

  if (error) return <div className="tenant-loading">{error}</div>;
  if (!apercu) return <div className="tenant-loading">Chargement...</div>;

  return (
    <TenantLayout apercu={apercu}>
      {page === 'dossier'
        ? <TenantDossierPage apercu={apercu} />
        : <TenantDashboardPage apercu={apercu} />}
    </TenantLayout>
  );
};

export default ApercuEspaceLocatairePage;
